import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import ComponentTag from '@cred/react-component-tag'

import * as packageJson from './package.json'

const getThemeClasses = (themeName) => {
  const loadedStyles = {
    credible3a11y: require('./themes/credible3a11y.module.scss') /* Default fallback theme */
  }

  // The following code is for adding new themes:
  //
  switch (themeName) {
    case 'credible3':
      loadedStyles.credible3 = require('./themes/credible3.module.scss')
      break
    case 'nypost':
      loadedStyles.nypost = require('./themes/nypost.module.scss')
      break
    case 'nerdwallet':
      loadedStyles.nerdwallet = require('./themes/nerdwallet.module.scss')
      break
    case 'bankrate':
      loadedStyles.bankrate = require('./themes/bankrate.module.scss')
      break
    case 'juno':
      loadedStyles.juno = require('./themes/juno.module.scss')
      break
    case 'investopedia1':
      loadedStyles.investopedia1 = require('./themes/investopedia1.module.scss')
      break
    case 'insider':
      loadedStyles.insider = require('./themes/insider.module.scss')
      break
    case 'fox1':
    case 'fox':
      loadedStyles.fox1 = require('./themes/fox1.module.scss')
      break
    case 'foxBusiness':
      loadedStyles.fox1 = require('./themes/foxBusiness.module.scss')
      break
    case 'forbes1':
      loadedStyles.forbes1 = require('./themes/forbes1.module.scss')
      break
    case 'homes1':
      loadedStyles.homes1 = require('./themes/homes1.module.scss')
      break
    case 'thebalance1':
      loadedStyles.thebalance1 = require('./themes/thebalance1.module.scss')
      break
    case 'yahoo1':
    case 'yahoo':
      loadedStyles.yahoo1 = require('./themes/yahoo1.module.scss')
      break
    case 'loandepot':
      loadedStyles.loandepot = require('./themes/loandepot.module.scss')
      break
    case 'foxmoney':
      loadedStyles.foxmoney = require('./themes/foxmoney.module.scss')
      break
    case 'newsweek':
      loadedStyles.newsweek = require('./themes/newsweek.module.scss')
      break
    case 'wsj':
      loadedStyles.wsj = require('./themes/wsj.module.scss')
      break
  }

  return Object.keys(loadedStyles).map((key) => loadedStyles[key].theme || loadedStyles[key]?.default?.theme)
}

const Theme = ({ themeName, children, className, componentTag }) => {
  const classNames = getThemeClasses(themeName)

  return (
    <div className={cx(classNames.join(' '), className)} {...componentTag}>
      {children}
    </div>
  )
}

Theme.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.element,
    PropTypes.func
  ]).isRequired,
  themeName: PropTypes.string,
  className: PropTypes.string,
  componentTag: PropTypes.object
}

export default ComponentTag(packageJson)(Theme)
